import React, { PropTypes } from 'react';
import classnames from 'classnames';
import upperFirst from 'lodash/upperFirst';
import { Range } from 'rc-slider';
import Slider from 'common/components/slider';

const ReferenceSlider = ({ money, value, references: { lowMax, fairMax, goodMax } }) => {
  let handleLabel;

  if (value > goodMax) {
    handleLabel = "great";
  } else if (value > fairMax) {
    handleLabel = "good";
  } else if (value > lowMax) {
    handleLabel = "fair";
  } else {
    handleLabel = "low";
  }

  const handle = ({ className, offset, handleStyle, ...restProps }) => (
    <div className={className} style={{ left: `${offset}%`, ...handleStyle }}>
      <h5>{ upperFirst(handleLabel) }</h5>
    </div>
  );
  const marks = [lowMax, fairMax, goodMax].reduce((acc, n) => ({
    ...acc,
    [n]: `${money? '$' : ''}${n}`
  }), {});

  return (
    <Slider
      handle={handle}
      marks={marks}
      className={classnames("reference-slider", handleLabel)}
      min={0}
      max={goodMax + lowMax /* just to make the first and last marks symetrical */}
      value={value}
    />
  );
}

ReferenceSlider.propTypes = {
  money: PropTypes.bool,
  value: PropTypes.number.isRequired,
  references: PropTypes.object.isRequired
};

export default ReferenceSlider;
